var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-toolbar',{staticClass:"elevation-0 flex-wrap",attrs:{"height":"56px"}},[_vm._t("left"),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }